// @flow
import { SavedTranscript } from '../types/saved-transcript';

export const filterAccessibleTranscripts = (
  currentTranscripts: SavedTranscript[],
  newTranscripts: SavedTranscript[]
) => {
  const updatedTranscripts = [];

  const transcriptMapping = {};
  currentTranscripts.forEach((transcript: SavedTranscript) => {
    if (!(transcript.roomId in transcriptMapping)) {
      transcriptMapping[transcript.roomId] = true;
      updatedTranscripts.push(transcript);
    }
  });
  newTranscripts.forEach((transcript: SavedTranscript) => {
    if (!(transcript.roomId in transcriptMapping)) {
      transcriptMapping[transcript.roomId] = true;
      updatedTranscripts.push(transcript);
    }
  });

  const filteredTranscripts: SavedTranscript[] = updatedTranscripts.filter(transcript => {
    return transcript.hasTranscripts && transcript.isAllowedAccess && !transcript.deleted;
  });

  return filteredTranscripts;
};

export const retrieveLastReadTranscript = (newTranscripts: SavedTranscript[]) =>
  newTranscripts[newTranscripts.length - 1];

export const filterDeletedTranscript = (currentTranscripts: SavedTranscript[], deletedTranscript: SavedTranscript) => {
  const filteredTranscripts: SavedTranscript[] = currentTranscripts.filter(
    (transcript: SavedTranscript) => transcript.roomId !== deletedTranscript.roomId
  );

  return filteredTranscripts;
};

export const updateTranscripts = (currentTranscripts: SavedTranscript[], updatedTranscript: SavedTranscript) => {
  const updatedTranscripts = [...currentTranscripts];
  for (let i = 0; i < updatedTranscripts.length; i += 1) {
    if (updatedTranscripts[i].roomId === updatedTranscript.roomId) {
      updatedTranscripts[i] = { ...updatedTranscript };
      break;
    }
  }

  return updatedTranscripts;
};
